module.exports = __webpack_public_path__ + "img/yg.84c98c8c.png";